import React from 'react';
import FluxAutomaticWrapper from 'components/RouteWrappers/Flux/Automatic';
import Daily from 'views/Flux/Automatic/Daily';
import Monthly from 'views/Flux/Automatic/Monthly';
import Revision from 'views/Flux/Automatic/Revision';
import Unicenario from 'views/Flux/Automatic/Unicenario';
import Classic from 'views/Flux/Automatic/Classic';
import Vobs from 'views/Flux/Automatic/Vobs';

const automaticRouter = {
  path: 'automatic',
  element: <FluxAutomaticWrapper />,
  children: [
    { path: 'classic', element: <Classic /> },
    { path: '', element: <Daily /> },
    { path: 'monthly', element: <Monthly /> },
    { path: 'revision', element: <Revision /> },
    { path: 'unicenario', element: <Unicenario /> },
    { path: 'vobs', element: <Vobs /> },
  ],
};

export default automaticRouter;
